import * as fetch from "../../common/fetch";

import {
  AttributeMetadataCreateRequestType,
  AttributeMetadataDeleteRequestType,
  AttributeMetadataMoveDataRequestType
} from "../requests/attributeMetdataRequestTypes";

import {
  AttributeMetadataCreateResponseType,
  AttributeMetadataGetAllResponseType,
  AttributeMetadataGetByIdResponseType
} from "../responses/attributeMetadataResponseTypes";

const url = process.env.WIB_API_URL;

export async function create(request: AttributeMetadataCreateRequestType) {
  const response = await fetch.post(`${url}/attribute-metadata`, request);

  if (response.ok) {
    const responseJson = await response.json();
    return responseJson as AttributeMetadataCreateResponseType;
  }
}

export async function del(id, body: AttributeMetadataDeleteRequestType) {
  const response = await fetch.del(`${url}/attribute-metadata/${id}`, body);

  return response.ok;
}

export async function getAll() {
  const response = await fetch.get(`${url}/attribute-metadata`);

  if (response.ok) {
    const responseJson = await response.json();
    return responseJson as AttributeMetadataGetAllResponseType;
  }
}

export async function getById(id) {
  const response = await fetch.get(`${url}/attribute-metadata/${id}`);

  if (response.ok) {
    const responseJson = await response.json();
    return responseJson as AttributeMetadataGetByIdResponseType;
  }
}

export async function updateAttribute(
  id,
  label,
  description,
  personalInfo,
  singleValueExtractionPreference?,
  sensitivityClassificationType?,
  sensitivityClassificationLabel?
) {
  const response = await fetch.put(`${url}/attribute-metadata/${id}`, {
    label,
    description,
    personalInfo,
    singleValueExtractionPreference,
    sensitivityClassificationType,
    sensitivityClassificationLabel
  });

  if (response.ok) {
    const responseJson = await response.json();
    return responseJson as AttributeMetadataGetByIdResponseType;
  }
}

export async function moveData(request: AttributeMetadataMoveDataRequestType) {
  const response = await fetch.post(
    `${url}/attribute-metadata/move-data`,
    request
  );

  return response.ok;
}
